<template>
    <div
        class="d-inline-flex border-top timeline-row"
        :class="isActive ? '' : 'bg-disabled'"
    >
        <div class="d-flex align-items-center pl-2 day-timeline-width">
            <toggle-input
                :id="`toggle-${day.day}`"
                :value="isActive"
                @input="onToggleChange"
                :label="displayDay(day.day)"
            />
        </div>
        <div
            v-if="isActive"
            class="position-relative"
            :style="{ width: hourSectionWidth }"
        >
            <slot></slot>
        </div>
        <div
            v-if="isActive"
            class="d-flex align-items-center flex-grow-1 justify-content-end"
        >
            <button
                class="btn btn-sm btn-secondary mx-1"
                @click="$emit('add', day)"
                v-b-tooltip.hover.top
                title="New Hours Block"
            >
                <i class="fas fa-plus"></i>
            </button>
        </div>
    </div>
</template>

<script>
import ToggleInput from "@/components/commons/toggle-input";
import CLINIC_HOUR from "@/constants/clinic-hour";

export default {
    inject: {
        getRangeBetweenBlock: {
            from: "rangeBetweenBlock"
        }
    },
    components: {
        ToggleInput
    },
    props: {
        day: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isActive: this.day.isactive
        };
    },
    computed: {
        hourSectionWidth() {
            return this.getRangeBetweenBlock() * 60 * 25 + "px";
        }
    },
    watch: {
        day: {
            handler(newValue) {
                this.isActive = newValue.isactive;
            },
            deep: true
        }
    },
    methods: {
        displayDay(day) {
            return CLINIC_HOUR.DAYS[String(day)];
        },
        onToggleChange(value) {
            this.isActive = value;
            this.$emit("toggle", { ...this.day, isactive: value });
        }
    }
};
</script>

<style scoped>
.bg-disabled {
    background-color: #edeff2;
}

.timeline-row {
    height: 52px;
}

.timeline-row.bg-disabled {
    width: 100%;
}
</style>
